import styled from "styled-components";
import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import { FormWrapper } from "../../../styles/shared";

export const VisuallyHiddenInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  white-space: nowrap;
  width: 1px;
`;

export const PageWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 0 0 0;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    padding: 24px 0 0 0;
    margin-bottom: 32px;
  }
  
  h1 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    @media (min-width: 768px) {
      font-size: 32px;
      gap: 12px;
    }
    
    i {
      color: #f29205;
      font-size: 28px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
      
      @media (min-width: 768px) {
        font-size: 36px;
      }
    }
  }
`;

export const ModernCard = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(242, 146, 5, 0.2);
  overflow: hidden;
  border: 1px solid rgba(242, 146, 5, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
  
  @media (max-width: 767px) {
    border-radius: 16px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(242, 146, 5, 0.3);
  }
`;

export const CardBody = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #e0e0e0;
  
  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const UploadCard = styled.div`
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
  border-radius: 16px;
  padding: 28px;
  border: 2px solid rgba(0, 212, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    border-color: rgba(0, 212, 255, 0.4);
    box-shadow: 0 12px 40px rgba(0, 212, 255, 0.2);
  }
  
  .card-title {
    color: #00d4ff;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .card-text {
    color: #b0b0b0;
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

export const StyledTabs = styled(Box)`
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 32px;
  
  .MuiTabs-root {
    .MuiTab-root {
      color: #b0b0b0;
      font-size: 16px;
      font-weight: 600;
      text-transform: none;
      min-height: 64px;
      padding: 16px 32px;
      transition: all 0.3s ease;
      
      &:hover {
        color: #00d4ff;
        background: rgba(0, 212, 255, 0.05);
      }
    }
    
    .Mui-selected {
      color: #00d4ff !important;
      font-weight: 700;
    }
    
    .MuiTabs-indicator {
      background: linear-gradient(90deg, #00d4ff 0%, #0099cc 100%);
      height: 4px;
      border-radius: 4px 4px 0 0;
    }
  }
`;

export const ModernTableContainer = styled(TableContainer)`
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  
  .MuiTable-root {
    .MuiTableHead-root {
      background: linear-gradient(135deg, #0a2647 0%, #0f3460 100%);
      
      .MuiTableCell-head {
        color: #00d4ff;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 0.5px;
        border-bottom: 2px solid rgba(0, 212, 255, 0.3);
        padding: 16px;
      }
    }
    
    .MuiTableBody-root {
      .MuiTableRow-root {
        background: rgba(255, 255, 255, 0.02);
        transition: all 0.2s ease;
        
        &:hover {
          background: rgba(0, 212, 255, 0.05);
        }
        
        .MuiTableCell-root {
          color: #e0e0e0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          padding: 16px;
          
          input {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            color: #ffffff;
            padding: 10px 14px;
            transition: all 0.2s ease;
            
            &:focus {
              background: rgba(255, 255, 255, 0.08);
              border-color: #00d4ff;
              outline: none;
              box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
            }
            
            &::placeholder {
              color: #888;
            }
          }
        }
      }
    }
  }
`;

export const SectionTitle = styled.h6`
  color: #00d4ff;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (min-width: 768px) {
    font-size: 18px;
    gap: 10px;
  }
  
  i {
    font-size: 18px;
    
    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const SectionSubtitle = styled.p`
  color: #b0b0b0;
  font-size: 13px;
  margin-bottom: 20px;
  
  @media (min-width: 768px) {
    font-size: 14px;
    margin-bottom: 24px;
  }
`;

export const Divider = styled.hr`
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 24px 0;
  
  @media (min-width: 768px) {
    margin: 32px 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (min-width: 768px) {
    gap: 16px;
    margin-top: 32px;
    padding-top: 24px;
  }
  
  a {
    text-decoration: none;
  }
  
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
    
    > a {
      width: 100%;
      display: block;
    }
    
    .mobile-button,
    > a .mobile-button,
    > .mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
      
      .MuiButton-root {
        height: 48px !important;
        min-height: 48px !important;
      }
    }
  }
`;

// Importando FormWrapper compartilhado
export { FormWrapper } from "../../../styles/shared";

export const DescriptionTextarea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Nunito', Helvetica, Sans-Serif;
  resize: vertical;
  min-height: 100px;
  transition: all 0.3s ease;
  
  @media (min-width: 768px) {
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 15px;
    min-height: 120px;
  }
  
  @media (min-width: 992px) {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 16px;
    min-height: 140px;
  }
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.08);
    border-color: #00d4ff;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

